// Mirrors NotificationTemplate.RECIPIENT_USER_CHOICES in
// backend/notification/models.py -- dev-managed choices, kept in sync by hand.
export const RECIPIENT_USER_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "— None —" },
  { value: "booking.customer", label: "Booking Customer" },
  { value: "booking.created_by", label: "Booking Creator" },
  { value: "booking.referral.user", label: "Referral User" },
  { value: "booking.assigned_crew", label: "Assigned Crew" },
  { value: "stream.created_by", label: "Stream Creator" },
  { value: "venue.created_by", label: "Venue Owner" },
];
